import { useContext } from "react";
import { copy } from "../../constants";
import { LanguagesContext } from "../../contexts";

export function useCustomTranslation(text: string) {
  const { language } = useContext(LanguagesContext);

  return copy[language][text] || text;
}
